import React from 'react'

export default function HandIcon(Props) {
  return (
    <svg
      version="1"
      viewBox="0 0 500 500"
      stroke={Props.strokeColour}
      strokeWidth={Props.outline}
      fill={Props.color}
      opacity={0.6}
      width={Props.width}
      height={Props.height}>
      <path
        d="M1467 2885c-94-24-165-63-239-133-75-71-125-158-148-261-15-64-8-198 13-256 25-70 96-86 133-29 15 22 16 33 4 94-26 136 3 242 90 334 74 79 150 111 260 111s186-32 260-111c74-78 94-129 94-239 0-49-4-109-8-132-8-37-6-44 17-67 53-53 108-24 132 69 29 113 14 249-40 355-29 58-113 151-171 191-108 74-275 105-397 74zM453 2517c-91-91-113-118-113-141s21-51 107-137c98-100 110-109 144-109 71 0 92 73 39 134l-31 35 165 3c145 3 166 5 185 22 27 25 28 79 1 106-18 18-33 20-187 20H596l31 33c17 17 34 42 37 53 13 43-31 94-81 94-10 0-68-51-130-113zM2534 2618c-28-13-47-54-38-82 3-11 20-36 37-53l31-33h-167c-154 0-169-2-187-20-27-27-26-81 1-106 18-17 42-20 186-24l164-5-30-29c-57-54-34-136 38-136 34 0 46 9 144 109 86 86 107 114 107 137s-22 50-113 141c-114 114-129 123-173 101z"
        transform="matrix(.1 0 0 -.1 0 333)"></path>
      <path
        d="M1500 2574c-43-19-67-40-89-79-14-27-17-97-21-615l-5-585-66 110c-71 119-119 164-202 186-90 24-220-13-257-73-40-66-36-77 176-444 108-186 207-355 220-375 70-103 195-194 324-235 81-25 503-32 610-10 221 46 394 205 466 426 15 47 18 104 22 391 2 222 0 350-7 376-30 109-151 164-251 113-39-20-39-20-45 0-10 31-54 79-89 97-50 26-137 22-183-9l-39-26-34 40c-55 66-138 86-217 53-19-8-37-15-39-15s-4 116-4 258c0 148-5 273-11 295-13 47-63 106-106 123-42 18-109 17-153-2z"
        transform="matrix(.1 0 0 -.1 0 333)"></path>
    </svg>
  )
}
